import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { KhoiPhucPhieu } from "./KhoiPhucPhieu";

export const BtnKhoiPhucPhieu = ({ item, onDaKhoiPhuc }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <a onClick={() => setShow(true)} href={() => false}>
        <PopoversBootrap
          contentText="Khôi phục"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img
            style={{ marginLeft: "5px" }}
            src="/app-assets/images/icon-thu-hoi-v2.png"
            alt="Khôi phục"
          />
        </PopoversBootrap>
      </a>
      {show && (
        <KhoiPhucPhieu
          show={show}
          onHide={() => setShow(false)}
          item={item}
          onDaKhoiPhuc={onDaKhoiPhuc}
        />
      )}
    </>
  );
};
